import { useCallback } from "react";
import { navLogin } from "@/utils/nav";
import { useModel } from "@@/exports";
import { getLogout } from "@/openapi/manage/user";

export const useLogout = () => {
  const { setInitialState } = useModel("@@initialState");
  const { resetPingAnCheckData } = useModel("useCommonModel");
  const { resetModalModel } = useModel("useModalModel");
  return useCallback(async () => {
    /**
     * 生产环境和预发布环境执行退出登录
     * 测试和开发环境只本地清空登录信息
     */
    if (REACT_APP_ENV === "pre" || REACT_APP_ENV === "prod") {
      try {
        await getLogout();
      } catch (error) {
        throw new Error("退出登录失败");
      }
    }
    setInitialState((s) => ({ ...s, currentUser: undefined }));
    /**
     * 清除平安鉴权数据
     */
    resetPingAnCheckData();
    /**
     * 清除弹窗弹出数据
     */
    resetModalModel();
    navLogin();
  }, [resetModalModel, resetPingAnCheckData, setInitialState]);
};
